import { Box, Stack } from "@mui/system";
import { motion } from "framer-motion";
import { useState } from "react";

export default function Student(props: { id: string; _class: string }) {
  const { id, _class } = props;

  const [isAbsent, setIsAbsent] = useState(false);

  return (
    <Stack
      onClick={() => setIsAbsent(!isAbsent)}
      component={motion.div}
      justifyContent="flex-start"
      alignItems="flex-end"
      p={2}
      sx={{
        height: "30vh",
        position: "relative",
        filter: isAbsent ? "grayscale(100%)" : "none",
        opacity: isAbsent ? ".3" : "1",
        background: "linear-gradient(to top, #FFFFFF, rgba(255,255,255,0.9))",
        borderRadius: 10,
        boxShadow: "0px 10px 13px -10px rgba(0,0,0,.2)",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          left: 15,
          fontSize: "18em",
          lineHeight: "0.8em",
          color: "rgba(0,0,0,.2)",
          zIndex: 1,
        }}
      >
        {id.substring(0, 1).toUpperCase()}
      </Box>

      <Box
        component={motion.div}
        sx={{
          position: "relative",
          aspectRatio: "1/1",
          height: "100%",
          maxWidth: "100%",
          overflow: "hidden",
          borderRadius: "50%",
          boxShadow: "0px 6px 13px 5px rgba(0,0,0,.2)",
          border: "5px solid rgba(255,255,255,.2)",
          zIndex: 2,
        }}
      >
        <img
          src={`./class/${_class}/${id}.jpeg`}
          alt={id}
          style={{ width: "100%", height: "100%" }}
        />
      </Box>
    </Stack>
  );
}
